<template>
  <main role="Chat">
    <div class="row">
      <Chatroom />
    </div>
  </main>
</template>

<script>
import Chatroom from "/src/components/seller/Chat/Chatroom";
export default {
  components: {
    Chatroom,
  },
};
</script>